/** Parse/format PIF date strings as local calendar days (avoids UTC shift on YYYY-MM-DD). */

export const parsePifDate = (dateStr: string): Date | null => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

export const formatPifDate = (date: Date | null): string => {
  if (!date || Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

/**
 * Bug 83249: Date of birth and Intended start date take keyboard input.
 * MUI publishes an Invalid Date while a section is still being typed. Writing
 * that back as "" makes the controlled value snap empty and the keystroke
 * disappears. null means "still typing — leave the stored value alone".
 * A cleared field is "".
 */
export const pifDateFromPicker = (date: Date | null): string | null => {
  if (date !== null && Number.isNaN(date.getTime())) return null;
  return formatPifDate(date);
};
